/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";
import CTA from "../components/cta";

class BestVersion extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="section-7-et block-3 z-19 mb-2">
                    <div className="container relative-text p-40">
                        <div className="row">
                            <div className="col s12 m12 left-align">
                                <h1 className="f-38 white-text bold-text text-uppercase mobile-center mb0">This is where you become<br/><span className="f-62 ls-5 white-text">the best version of <br/></span><span className="f-100 ls-5 white-text">Yourself</span> </h1>
                                <p className="f-18 white-text mobile-center">We instantly focus on you, your business, and your brand. We begin providing you the value that can help you make the right next step on your journey.</p>
                                <br/>
                            </div>
                            <div className="col s12 m12 left-align mobile-center">
                                <CTA/>
                                <br/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default BestVersion;


// WEBPACK FOOTER //
// ./src/components/best-version.js